$(function () {
  'use strict';

  var $window = $(window);
  var $document = $(document);
  var scroll = $document.scrollTop();
  var $header = $('#header');
  var header_height = $header.outerHeight();
  var has_scroll = true;
  var has_resize = false;
  var is_sticky = false;

  // Early exit
  if(!$header.length) return;

  var update = function () {
    if(has_scroll) {
      var scroll = $document.scrollTop();

      if(scroll > header_height * 1.5 && !is_sticky) {
        $header.addClass('is-sticky');
        is_sticky = true;
      } else if(scroll <= header_height * 1.5 && is_sticky) {
        $header.removeClass('is-sticky');
        is_sticky = false;
      }
    }

    if(has_resize) {
      header_height = $header.outerHeight();
    }

    has_scroll = false;
    window.requestAnimationFrame(update);
  };

  $window.on("scroll", function() {
    has_scroll = true;
  });

  $window.on('resize', function () {
    has_resize = true;
  });

  update();
});
